import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifErrorMessage,
} from "@ey-xd/motif-react";
import React, { useEffect } from "react";
import "./ConfirmationModal.scss";

type Props = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  cancelButtonHandler: () => void;
  confirmButtonHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  header?: string;
  message?: string | React.ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  loading?: boolean;
  error?: string;
};

export default function ConfirmationModal({
  isVisible,
  setIsVisible,
  cancelButtonHandler,
  confirmButtonHandler,
  header,
  message,
  cancelLabel = "Keep working",
  confirmLabel = "Discard changes",
  loading = false,
  error,
}: Props) {
  useEffect(() => {
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <MotifModal
      onClose={() => {
        setIsVisible(false);
        cancelButtonHandler();
      }}
      show={isVisible}
      size="sm"
      className="confirmationModalWrapper"
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <MotifModalHeader>{header}</MotifModalHeader>
      <MotifModalBody>
        <div className="confirmationModalMessage">{message}</div>
        {error && (
          <MotifErrorMessage variant="error" showIcon>
            {error}
          </MotifErrorMessage>
        )}
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          type="button"
          size="small"
          variant="secondary"
          onClick={cancelButtonHandler}
          disabled={loading}
        >
          {cancelLabel}
        </MotifButton>
        <MotifButton
          type="button"
          size="small"
          variant="primary"
          loading={loading}
          onClick={confirmButtonHandler}
        >
          {confirmLabel}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}
